module.exports = __webpack_public_path__ + "img/play.cb30affb.png";